import Logo from '@/components/icons/Logo';
import { MendableFloatingButton, MendableSearchBar } from '@mendable/search';
import Link from 'next/link';

const company = 'Geoguessr';
const anon_key = '762a3d36-7422-4854-a7fe-56fb209e790a';

export default function Geoguessr({ history }: { history: any }) {
  const DefaultLightStyle: any = {
    primaryColor: '#f5f5f5',
    accentColor: '#1FD085',
    textColor: '#1a1a1a',
    inputBackgroundColor: '#f3f3f3',
    buttonTextColor: '#ffffff'
  };

  const DefaultLightMessageStyle: any = {
    darkMode: false,
    aiTextColor: '#1a1a1a',
    userTextColor: '#1a1a1a',
    accentColor: '#1FD085'
  };

  const DefaultLightFloatingButtonStyle: any = {
    color: '#ffffff',
    backgroundColor: '#1FD085'
  };
  const DefaultLightSourcesStyle = {
    accentColor: '#1FD085',
    darkMode: false
  };
  return (
    <div className="relative w-full bg-black overflow-hidden h-screen flex flex-col items-center justify-center">
      <img
        src="/geobg.jpeg"
        className="absolute  w-full h-full object-cover opacity-75 "
      />
      <div className="relative w-full overflow-hidden h-screen flex flex-col items-center justify-start z-10 p-4">
        <div className="mt-40 mb-10 self-center">
          {/* <Link href="https://mendable.ai">
          <img
            src="/SideGuideLogoNew (11).png"
            className="w-8 h-8 sm:w-16 sm:h-16  hover:cursor-pointer"
          />
        </Link> */}
        </div>
        <h3 className="text-2xl sm:text-3xl text-white text-center flex items-center flex-col sm:flex-row justify-center  mb-4 ">
          Ask questions to{' '}
          <img src="/Frame 560.png" className=" m-0 p-0 h-20 sm:h-32" />
        </h3>
        <div className="mt-4 w-full max-w-xl box-shadow-soft-geo rounded-full">
          <MendableSearchBar
            style={{ darkMode: false, accentColor: '#C52E2C' }}
            //   floatingButtonStyle={{ color: '#ffffff', backgroundColor: '#C52E2C' }}
            anon_key={anon_key}
            placeholder="Chat about any GeoGuessr tips"
            //   botIcon={<img src="/world.png" className="rounded-full p-1" />}
            //   icon={
            //     <img
            //       src="/location.png"
            //       style={{ width: '48px', height: '48px' }}
            //     />
            //   }
          />
        </div>

        <p className="mt-4 text-base sm:text-lg text-white text-center max-w-xl  ">
          Trained based on{' '}
          <a
            className="font-bold"
            href="https://www.youtube.com/channel/UCqcxR9B59H4DT1e6hg1Smiw"
          >
            @Zig8zag
          </a>{' '}
          and{' '}
          <a className="font-bold" href="https://www.youtube.com/@georainbolt">
            @Rainbolt
          </a>{' '}
          YouTube videos + famous{' '}
          <a
            className="font-bold"
            href="https://somerandomstuff1.wordpress.com/2019/02/08/geoguessr-the-top-tips-tricks-and-techniques"
          >
            blog post
          </a>{' '}
        </p>
        <div className="sm:flex-1"></div>
        <div className="mt-20 sm:mt-0 flex flex-row items-center justify-center text-base sm:text-lg mb-10 sm:mb-0">
            Powered by
            <img
              src="/SideGuideLogoNew (11).png"
              className="ml-3 h-5 sm:h-7  hover:cursor-pointer"
            />
            <a
              className="ml-2 font-bold text-white shadow-sm"
              href="https://mendable.ai"
            >
              Mendable.ai
            </a>
        </div>
      </div>
    </div>
  );
}
